export type VipTierBand = 'basic' | 'tier1' | 'tier2' | 'tier3';

/**
 * 공유 카드 배경은 VIP 티어 단일 값이 아니라 구간별로 달라짐
 * basic(0) / VIP 1~3 / VIP 4~7 / VIP 8 이상
 */
export const getVipTierBand = (vipTier?: number): VipTierBand => {
  if (!vipTier || vipTier <= 0) return 'basic';
  if (vipTier <= 3) return 'tier1';
  if (vipTier <= 7) return 'tier2';
  return 'tier3';
};

/** basic 유저(티어 0 또는 미조회)에게는 VIP 배지를 노출하지 않음 */
export const shouldShowVipBadge = (vipTier?: number): boolean => getVipTierBand(vipTier) !== 'basic';

/** VARA(spot only) 규제 대상 유저에게는 referral code 섹션을 노출하지 않음 */
export const shouldShowReferralSection = (isSpotOnly: boolean): boolean => !isSpotOnly;
